import { Check } from "lucide-react";

import { IgTypography } from "@intelligems/ig-theme";
import { LivePriceDto } from "@intelligems/ig-types";
import { Grid } from "@mui/material";
import { theme } from "@src/theme";

interface FeaturesRowProps {
  price: LivePriceDto;
}
export const FeaturesRow = ({ price }: FeaturesRowProps) => {
  return (
    <Grid
      container
      item
      rowSpacing={0.5}
      sx={{ marginTop: "10px" }}
      className={"ig-price-features"}
    >
      {price.features.map((feat, index) => (
        <Grid
          container
          item
          key={`${price.id}-feat-${index}`}
          columnSpacing={1.5}
          flexWrap={"nowrap"}
        >
          <Grid item>
            <Check size={18} />
          </Grid>
          <Grid item>
            <IgTypography sx={{ color: theme.palette.text.secondary }}>
              {feat}
            </IgTypography>
          </Grid>
        </Grid>
      ))}
    </Grid>
  );
};
